<script>
export default {
    name: 'CreditCardType',

    data() {
        return {}
    },
    methods: {
        getCardType(input) {
            var visa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
            var mastercard = new RegExp("^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$");
            var discover = new RegExp("^6(?:011|5[0-9]{2})[0-9]{12}$");
            var american = new RegExp("^3[47][0-9]{13}$");
            var diners = new RegExp("^3(?:0[0-5]|[68][0-9])[0-9]{11}$");

            if(visa.test(input)) {
                return "Visa";
            }
            else if(mastercard.test(input)) {
                return "Mastercard";
            }
            else if(american.test(input)) {
                return "American Express";
            }
            else if(diners.test(input)) {
                return "Mastercard";
            }
            else if(discover.test(input)) {
                return "Discover";
            }
            else {
                return "";
            }
        },
    }
}
</script>
